import { Link } from 'react-router-dom'

/**
 * "I agree to the terms of service and privacy policy", with both linked. The
 * links open in a new tab, so reading them does not throw away a half-filled
 * form. Shared by signup and by finishing signup, so both say exactly the same.
 */
export function LegalConsent({
  checked,
  onChange,
  id = 'legal-consent',
}: {
  checked: boolean
  onChange: (checked: boolean) => void
  id?: string
}) {
  return (
    <label htmlFor={id} className="flex items-start gap-2 text-sm text-ink">
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 h-4 w-4 rounded border-line"
      />
      <span>
        I agree to the{' '}
        <Link to="/terms" target="_blank" className="underline underline-offset-2">
          terms of service
        </Link>{' '}
        and the{' '}
        <Link to="/privacy" target="_blank" className="underline underline-offset-2">
          privacy policy
        </Link>
        .
      </span>
    </label>
  )
}
